import React from 'react'
import PropTypes from 'prop-types'
import formatCatalogueNumber from '../../helpers/formatCatalogueNumber'

import * as Styled from './Name.styles'

class Name extends React.PureComponent {
  render() {
    const { productName, excludedFromMoneyBack, catNumber } = this.props

    return (
      <Styled.ProductName data-test='product-name'>
        <Styled.Main className='h2' data-test='product-name-main'>
          <span itemProp='name' data-test='product-title'>
            {productName}
          </span>
          {excludedFromMoneyBack && <sup>&dagger;</sup>}
        </Styled.Main>
        {catNumber && (
          <Styled.CatNumber data-test='product-name-catNumber' itemProp='sku' content={catNumber}>
            {formatCatalogueNumber(catNumber)}
          </Styled.CatNumber>
        )}
      </Styled.ProductName>
    )
  }
}

Name.propTypes = {
  productName: PropTypes.string,
  catNumber: PropTypes.string,
  excludedFromMoneyBack: PropTypes.bool
}

export default Name
